import {
  RESET_ASSIGN_CUSTOMER_ACCOUNT_MANAGER,
  ASSIGN_CUSTOMER_ACCOUNT_MANAGER,
  ASSIGN_CUSTOMER_ACCOUNT_MANAGER_SUCCESS,
  ASSIGN_CUSTOMER_ACCOUNT_MANAGER_FAILURE,
} from "../../constants/Customers/AssignCustomerAccountManager";

// for employee information

export const ResetAssignCustomerAccountManager = (data) => {
  return {
    type: RESET_ASSIGN_CUSTOMER_ACCOUNT_MANAGER,
    payload: data,
  };
};

export const AssignCustomerAccountManager = (data) => {
  return {
    type: ASSIGN_CUSTOMER_ACCOUNT_MANAGER,
    payload: data,
  };
};
export const AssignCustomerAccountManagerSuccess = (payload) => {
  return {
    type: ASSIGN_CUSTOMER_ACCOUNT_MANAGER_SUCCESS,
    payload,
  };
};
export const AssignCustomerAccountManagerFailure = (payload) => {
  return {
    type: ASSIGN_CUSTOMER_ACCOUNT_MANAGER_FAILURE,
    payload,
  };
};
